import WedifyApiRequest from './wedify_api_request.js';

export const fetchCredits = async (currentUser) => {
    if (!currentUser) return;
    
    try {
      const wedifyApiRequest = new WedifyApiRequest();
      const response = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/login/generation/credits/left?authService=firebase&externalClientId=${currentUser.uid}`, "GET")
      if (response.ok) {
        return await response.text();
      }
    } catch (error) {
      console.error('Error fetching credits:', error);
    }
  };